export default __webpack_public_path__ + "static/media/cain9.c7ecc6bf.jpg";